import { IResponse } from "models";

export enum ActionType {
  VOICE_CALL = "action/VOICE_CALL",
  VOICE_CALL_SUCCESS = "action/VOICE_CALL_SUCCESS",
  VOICE_CALL_ERROR = "action/VOICE_CALL_ERROR",
  VOICE_CALL_RESET = "action/VOICE_CALL_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IVoiceCallPayload {
  mobile_number: string;
}

export interface IVoiceCallResponse extends IResponse {
  result: any;
}
